import React from "react";
import {TextField,} from "@mui/material";

export default function DHTextFieldMultiline({id, label, width, rows, maxLength, required, value, onChange}) {

    return <TextField id={id} label={label} variant="filled" style={{width: width}}
                      multiline
                      rows={rows}
                      slotProps={{ htmlInput: { maxLength: maxLength ? maxLength : 2000 } }}
                      required={required} value={value} onChange={(event) => onChange(event.target.value)}/>

}